import React, { useState } from "react";
import { Drawer, Button } from "antd";
import { useTranslation } from "react-i18next";
import "./index.css";
import { checkAuthorization, domainUrl } from "../../../shared";

const UserProfileDrawer = ({ visible, onClose }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const logout = () => {
    setLoading(true);
    const { userToken } = checkAuthorization();
    const myHeaders = new Headers();
    myHeaders.append("Authorization", userToken);
    fetch(domainUrl + "/logout", {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    })
      .then((res) => res.json())
      .then((result) => {
        if (result?.success) {
          localStorage.clear();
          window.location.href = "/";
        } else {
          throw new Error();
        }
      })
      .catch(() => {
        setLoading(false);
        localStorage.clear();
        window.location.href = "/";
      });
  };

  return (
    <Drawer
      title={t("Profile")}
      onClose={onClose}
      visible={visible}
      width={400}
      footer={
        <Button
          block
          type="primary"
          size="large"
          loading={loading}
          onClick={logout}
        >
          {t("Logout")}
        </Button>
      }
    >
      {/* Dil Seçici kaldırıldı */}
      {/* Buraya profil içeriği gelebilir */}
    </Drawer>
  );
};

export default UserProfileDrawer;
